import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';
import { Sale, defaultSaleValues } from '../models/salesModel';

const initialState:Sale = defaultSaleValues

interface SaleContextType {
  sale: Sale;
  updateSale: (newConfig: Partial<Sale>) => void;
}
interface SaleProviderProps {
  children: ReactNode;
}

const SaleContext = createContext<SaleContextType>({sale:initialState,updateSale:()=>{}});

export const SaleProvider:React.FC<SaleProviderProps> = ({ children }) => {
  const [sale, setSale] = useState(initialState);
  const updateSale = useCallback((newConfig:Partial<Sale>) => {
    setSale((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);

  const contextValue = useMemo(() => ({
    sale,
    updateSale,
  }), [sale, updateSale]);

  return (
    <SaleContext.Provider value={contextValue}>
      {children}
    </SaleContext.Provider>
  );
};

export const useSale = () => {
  return useContext(SaleContext);
};